import { Component, Inject, Input, OnInit, ViewChild } from '@angular/core';
import { AbstractControl, FormControl, UntypedFormControl, ValidationErrors, ValidatorFn } from '@angular/forms';
import { TableAction, TableHeader } from '@huge-monorepo/hip/domain';
import {
  GenericTableHeaderComponent,
  GenericTableHeaderOptions,
  RefreshData,
  SortItem,
  TableComponent,
  FilterItem,
} from '@huge-monorepo/shared/components';
import { ToolsService } from '@huge-monorepo/hip/services';
import { ToolsModule } from '@huge-monorepo/shared/tools';
import { MaterialModule } from '@huge-monorepo/shared/modules';
import { CommonModule } from '@angular/common';
import { MY_DATE_PICKER_FORMATS } from '@huge-monorepo/shared/components';
import { MomentDateAdapter } from '@angular/material-moment-adapter';
import * as _moment from 'moment';
import { DateAdapter, MAT_DATE_FORMATS, MAT_DATE_LOCALE } from '@angular/material/core';
import { default as _rollupMoment } from 'moment';
const moment = _rollupMoment || _moment;

@Component({
  selector: 'app-teltonika-audit-log',
  templateUrl: './teltonika-audit-log.component.html',
  styleUrls: ['./teltonika-audit-log.component.scss'],
  standalone: true,
    imports: [GenericTableHeaderComponent, ToolsModule, MaterialModule, CommonModule],

  providers: [
      { provide: DateAdapter, useClass: MomentDateAdapter, deps: [MAT_DATE_LOCALE] },
      { provide: MAT_DATE_FORMATS, useValue: MY_DATE_PICKER_FORMATS },
    ],
})
export class TeltonikaAuditLogComponent implements OnInit {
  @ViewChild('table', { static: false }) public table: TableComponent;

  report: any = {};

  DeviceNumberControl = new UntypedFormControl('');
  ActionControl = new UntypedFormControl('');
  UserControl = new UntypedFormControl('');

  auditLogHeaders: TableHeader[] = [
    {
      ID: 'ActionName',
      Index: 0,
      Sort: 'ActionName',
      Sortable: true,
      Text: 'Action',
      Type: String,
      Width: 150,
    },
    {
      ID: 'Description',
      Index: 1,
      Sort: 'Description',
      Sortable: true,
      Text: 'Description',
      Type: String,
      Width: 250,
      Wrapper: (obj: any, elem: any) => {
        if (!elem) return '-';
        return elem.length > 74 ? elem.substring(0, 74) + '...' : elem;
      },
      MatToolTip: (obj: any) => obj.Description
    },
    {
      ID: 'Device',
      Index: 2,
      Sort: 'Device',
      Sortable: true,
      Text: 'Device',
      Type: String,
      Width: 100,
      Wrapper: (_obj, elem) => {
        if (_obj.Device != null && _obj.Device.DeviceNum != null) {
          return _obj.Device.DeviceNum;
        }
        return '-';
      },
    },
    {
      ID: 'User',
      Index: 3,
      Sort: 'User',
      Sortable: true,
      Text: 'User',
      Type: String,
      Width: 100,
      Wrapper: (_obj, elem) => {
        let ret = elem.Name;
        if (elem.Surname != '') {
          ret += ' ' + elem.Surname;
        }

        if (elem.ID == 6) {
          ret = 'Proman User';
        }
        return ret;
      },
    },
    {
      ID: 'Timestamp',
      Index: 4,
      Sort: 'Timestamp',
      Sortable: true,
      Text: 'Timestamp',
      Type: String,
      Width: 150,
      Wrapper: (_obj, elem) => {
        return this.tools.FormatDateTimeFromDateSwedish(this.tools.ParseAPIDateWithTimezone(elem));
      },
    },
  ];

  baseURL = '/teltonika/auditlogs/';
  tableObj = {
    Start: this.tools.FormatStartDate(this.tools.GetStartOfMonth(new Date()).toISOString()),
    End: this.tools.FormatEndDate((new Date()).toISOString()),
    DeviceIds: null,
    UserIds: null,
    ActionName: '',
    DeviceNumber: '',
    User: '',
    DeviceIP: '',
  };

  notFutureDateValidator(): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => {
      const value = control.value;
      if (!value) {
        return { required: true };
      }
      const dateValue = new Date(value);
      if (dateValue > new Date()) {
        return { futureDate: true };
      }
      return null;
    };
  }

startDateControl = new FormControl<Date | null>(this.tools.GetStartOfMonth(new Date()), [this.notFutureDateValidator()]);
endDateControl = new FormControl<Date | null>(new Date(), [this.notFutureDateValidator()]);


  constructor(private tools: ToolsService) { }

  ngOnInit() {
    this.startDateControl.setValue(this.tools.GetStartOfMonth(new Date()));
    this.endDateControl.setValue(new Date());
    this.startDateControl.valueChanges.subscribe((value) => {
      this.updateStart(value);
    });
    this.endDateControl.valueChanges.subscribe((value) => {
      this.updateEnd(value);
    });
  }

  ngAfterViewInit() {
    //this.sideBar.setDrawer(this.drawer);
  }

  updateDates(returnedDates: any) {
    if (returnedDates.valid) {
      this.startDateControl.setValue(returnedDates.startDate);
      this.endDateControl.setValue(returnedDates.endDate);
    } else {
      this.startDateControl.setValue(null);
      this.endDateControl.setValue(null);
    }
  }

  updateStart(date: Date | null) {
    // console.log(this.report.StartDate, this.report.EndDate);
    if (!date) {
      this.report.StartDate = null;
      return;
    }
    date.setHours(0, 0, 0, 0);

    this.report.StartDate = this.tools.FormatStartDate(date.toISOString());
  }

  updateEnd(date: Date | null) {
    // console.log(date);
    if (!date) {
      this.report.EndDate = null;
      return;
    }
    date.setHours(23, 59, 59, 999);
    this.report.EndDate = this.tools.FormatEndDate(date.toISOString());
  }

  resetFields() {
    this.DeviceNumberControl.setValue('');
    this.startDateControl.setValue(this.tools.GetStartOfMonth(new Date()));
    this.endDateControl.setValue(new Date());
    this.ActionControl.setValue('');
    this.UserControl.setValue('');

    this.search();
  }

  search() {

    if (!this.startDateControl.valid ||
        !this.endDateControl.valid ||
        !this.startDateControl.value ||
        !this.endDateControl.value
    ) {
      return;
    }

    this.tableObj.Start = this.tools.FormatStartDate(this.startDateControl.value.toISOString());
    this.tableObj.End = this.tools.FormatEndDate(this.endDateControl.value.toISOString());
    this.tableObj.ActionName = this.ActionControl.value;
    this.tableObj.DeviceNumber = this.DeviceNumberControl.value;
    this.tableObj.User = this.UserControl.value;

    this.table.refresh();
  }
}
